import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import CheckBoxFreeBook from '@/components/ui/checkbox-free-book/CheckBoxFreeBook';
import { IBooksPageData, IBookPage } from '@/interfaces/booksPage.interface';

import { getPlainSearchWords } from '@/helpers/helpers';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

interface ISearchBooks {
  books: IBookPage;
  totalAlias: string;
  type: string;
  freeBooks?: boolean;
}

const SearchBooks: FC<ISearchBooks> = ({ books, totalAlias, type, freeBooks }) => {
  const pagesCount = Math.ceil(books.total_count / BOOKS_FOR_PAGE);
  const searchWords = getPlainSearchWords(totalAlias);

  const pagesType = {
    books: 'книги',
    audio_books: 'аудиокниги',
    drafts: 'черновика',
  };

  const pageName = pagesType[type as keyof typeof pagesType];

  const SEO_TITLE = `Результаты поиска по запросу "${searchWords}"`;
  const SEO_DESCRIPTION = 'Результаты поиска книг и авторов в библиотеке :: BookZ.ru.';
  const SEO_CANONICAL = `/search`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={SEO_CANONICAL} robotsNoFollow breadcrumbs={<Breadcrumbs firstPageName={`Поиск ${pageName}`} />}>
      <SectionTitle name={`Поиск ${pageName} по названию: «${searchWords}»`} />
      <CheckBoxFreeBook freeBooks={!!freeBooks} alias={`/search/${totalAlias}/${type}`} />
      <div>{books.data.length ? books.data.map((book: IBooksPageData) => <BookCardItem book={book} key={book.id} />) : <div>Книги не найдены</div>}</div>
      <Pagination defaultCurrentPage={books.page} pagesCount={pagesCount ?? 0} postName={freeBooks ? `search/${totalAlias}/${type}/?free_books=true&page=` : `search/${totalAlias}/${type}/page=`} />
    </Layout>
  );
};

export default SearchBooks;
